import Swiper from 'swiper';
import 'swiper/css';

export const initCollectionProductsSlider = (slider) => {
    const swiper = new Swiper(slider, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
            nextEl: ".js-collection-products-next",
            prevEl: ".js-collection-products-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 4.5,
            },
        },
    });
};

[...document.querySelectorAll('.js-collection-products-slider')].map(initCollectionProductsSlider);
